export const dateRangeKeys = (dateRange: [moment.Moment, moment.Moment] | undefined) => {
  if (!dateRange) return ''
  return `${dateRange[0].valueOf()}-${dateRange[1].valueOf()}`
}
